import React, { useContext } from "react";

export const makeContextConsumerHook = (ctx) => () => {
	const context = useContext(ctx);

	if (context === undefined) {
		throw new Error("Consumer must be used within a Provider");
	}

	return context;
};

export const makeWithContextProviderHOC =
	(Provider) =>
	(WrappedComponent, options = {}) =>
	(props) => (
		<Provider {...options}>
			<WrappedComponent {...props} />
		</Provider>
	);
